import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FlashNotification } from './store';

/*
    thoughts:
    - app provides feedback for user action; i.e., successful/failed form submission
    - app provides info about _something_; i.e., new documents, signature required, payment due in x days, etc
    - types of dismissal/level of persistence
        - notification that self dismisses; like 'something happened and here's feedback' and it dismisses itself in x seconds
        - something that has an x button to dismiss
        - something that has to be dismissed by a resolution; say new docs notification and navigating to docs dismisses it
*/

// for later. doing the timed one and can work the others when they're needed
//
// const toDoNotification

const StyledFlashNotifications = styled.div`
    left: 50%;
    min-width: 400px;
    max-width: calc(100% - 30px);
    position: fixed;
    top: 30px;
    transform: translate(-50%);
    @media (max-width: 767px) {
        min-width: calc(100% - 30px);
    }
`;

class FlashNotifications extends Component {
    static propTypes = {
        notifications: PropTypes.object.isRequired,
    };

    render() {
        const notifications = this.props.notifications.notifications;

        return (
            <StyledFlashNotifications className='z-exo flash-notification'>
                {Object.keys(notifications).map(key => {
                    const notification = notifications[key];
                    return (
                        <FlashNotification
                            notification={notification}
                            key={key}
                            notificationId={key}
                        />
                    );
                })}
            </StyledFlashNotifications>
        );
    }
}

export default FlashNotifications;
